import { render, staticRenderFns } from "./newPitData.vue?vue&type=template&id=b2186258"
import script from "./newPitData.vue?vue&type=script&lang=js"
export * from "./newPitData.vue?vue&type=script&lang=js"
import style0 from "./newPitData.vue?vue&type=style&index=0&id=b2186258&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports